export default "__VITE_ASSET__0a178263__"